<template>
  <Main>
    <template v-slot:breadcrumb>
      <BaseBreadcrumb
        @return="previousPage"
        :items="breadcrumb"
        class="d-none d-sm-flex"
      />
    </template>
    <template v-slot:breadcrumb-mobile>
      <BaseBreadcrumb @return="previousPage" :items="breadcrumb" />
    </template>
    <v-form ref="form" @submit.prevent="submit">
      <FormSection title="COMENTÁRIO" class="mb-10" v-if="userAreaIsGarantia">
        <v-col cols="12" class="mt-4">
          <BaseFormTextArea
            id-element="reasonCancelEndorsement"
            placeholder="Inserir"
            v-model="model.comentario"
            :rules="[maxLengthTextArea]"
          />
        </v-col>
      </FormSection>
      <v-divider v-if="userAreaIsGarantia" />
      <FormSection title="DOCUMENTOS" class="pt-9 mb-10" v-if="userAreaIsGarantia">
        <v-col cols="12">
          <v-row class="align-baseline">
            <v-col cols="12" md="10">
              <h5 class="primary--text">BALANÇOS</h5>
            </v-col>
            <v-col cols="12" md="2">
              <BaseButton
                outlined
                color="blue"
                style="width: 100%"
                @click="isBalanceDocumentModalOpen = true"
              >
                ADICIONAR
              </BaseButton>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" class="mt-4 mb-4">
          <BaseDataTable
            :headers="tableHeaders"
            :items="balanceDocuments.documents"
            hide-default-footer
            class="document-data-table"
          >
            <template v-slot:[`item.arquivo.nome`]="{ item }">
              <div class="d-flex">
                <v-icon class="primary--text pr-4">fa-file-pdf</v-icon>
                <span class="truncate">{{ item.arquivo.nome }}</span>
              </div>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <div class="d-flex">
                <BaseButton
                  color="secondary"
                  class="base-input-file__button px-0"
                  @click="removeDocument('balanceDocuments', item)"
                >
                  <img :src="require('@/assets/ic_trash.svg')" />
                </BaseButton>
              </div>
            </template>
          </BaseDataTable>
          <BaseErrorMessages
            v-if="errorBalance.length > 0"
            :error-messages="errorBalance"
          />
        </v-col>
        <v-col cols="12">
          <v-row class="align-baseline">
            <v-col cols="12" md="10">
              <h5 class="primary--text">DEMAIS ARQUIVOS</h5>
            </v-col>
            <v-col cols="12" md="2">
              <BaseButton
                outlined
                color="blue"
                style="width: 100%"
                @click="isOtherDocumentModalOpen = true"
              >
                ADICIONAR
              </BaseButton>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" class="mt-4">
          <BaseDataTable
            :headers="tableHeadersOthersDocuments"
            :items="otherDocuments.documents"
            hide-default-footer
            class="document-data-table"
          >
            <template v-slot:[`item.arquivo.nome`]="{ item }">
              <div class="d-flex">
                <v-icon class="primary--text pr-4">fa-file-pdf</v-icon>
                <span class="truncate">{{ item.arquivo.nome }}</span>
              </div>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <div class="d-flex">
                <BaseButton
                  color="secondary"
                  class="base-input-file__button px-0"
                  @click="removeDocument('otherDocuments', item)"
                >
                  <img :src="require('@/assets/ic_trash.svg')" />
                </BaseButton>
              </div>
            </template>
          </BaseDataTable>
        </v-col>
      </FormSection>
      <v-divider v-if="userAreaIsGarantia"/>
      <FormSection title="SEGURADORAS" class="pt-9 mb-10">
        <v-col cols="12" class="mt-4">
          <BaseDataTable
            :headers="tableHeadersInsurance"
            :items="insurers"
            show-select
            item-key="nome"
            v-model="selectedInsurance"
          />
          <BaseErrorMessages
            v-if="errorInsurance.length > 0"
            :error-messages="errorInsurance"
          />
        </v-col>
      </FormSection>
      <BaseFooter>
        <div class="d-flex justify-end">
          <BaseButton
            class="error text-uppercase subtitle-2 font-weight-bold"
            min-width="200"
            :to="{ name: 'economic_group credit_limit list' }"
          >
            Cancelar
          </BaseButton>
          <BaseButton
            type="submit"
            class="secondary text-uppercase subtitle-2 font-weight-bold ml-5"
            min-width="200"
          >
            {{ textSubmitButton }}
          </BaseButton>
        </div>
      </BaseFooter>
    </v-form>
    <SelectBalanceDocumentsModal
      v-if="isBalanceDocumentModalOpen"
      v-model="isBalanceDocumentModalOpen"
      :filterProps="filterProps"
      :headers="documentTableHeaders"
      :items="allBalanceDocuments"
      @select-items="
        document => this.selectDocument('balanceDocuments', document)
      "
      @close="onToggleBalanceModal"
      @complete="onToggleBalanceModal"
      :currentDocuments="balanceDocuments.documents"
    />
    <SelectOtherDocumentsModal
      v-if="isOtherDocumentModalOpen"
      v-model="isOtherDocumentModalOpen"
      :filterProps="filterProps"
      :headers="othersDocumentsTableHeaders"
      :items="allOtherDocuments"
      @select-items="item => this.selectDocument('otherDocuments', item)"
      @close="onToggleDocumentsModal"
      @complete="onToggleDocumentsModal"
      :currentDocuments="otherDocuments.documents"
    />
    <ModalCancelConsultMarket
      @close="closeModalCancel"
      v-model="modalCancel"
      title="SAIR SEM SALVAR"
      text="As alterações não foram salvas. Deseja realmente sair da tela?"
    />
  </Main>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import FormSection from "@/components/FormSection.vue";
import SelectDocumentsModal from "../components/SelectDocumentsModal.vue";
import ModalCancelConsultMarket from "../../insurance_company/components/ModalCancelInsurance";
import _ from "lodash";
import FormMixin from "@/mixins/FormMixin";
import { maxLengthTextArea } from "@/utils/rules.js";
const tableHeaders = [
  { text: "Título", value: "pessoa.nome", sortable: true },
  { text: "Documento anexado", value: "arquivo.nome", sortable: true },
  { text: "Ações", value: "actions", sortable: true }
];
const tableHeadersOthersDocuments = [
  { text: "Título", value: "pessoa.nome", sortable: true },
  { text: "Tipo", value: "tipo_documento.nome", sortable: true },
  { text: "Documento anexado", value: "arquivo.nome", sortable: true },
  { text: "Ações", value: "actions", sortable: true }
];
const tableHeadersInsurance = [
  { text: "Selecionar todos os Grupos", value: "nome", sortable: true }
];

const BREADCRUMB_HABILITAR_SEGURADORA = [
  {
    text: "Habilitar Seguradora",
    to: "economic_group"
  }
];
const BREADCRUMB_CONSULTAR_MERCADO = [
  {
    text: "Consultar Mercado",
    to: "economic_group"
  }
];

const defaultFilterProps = {
  outlined: true,
  dense: true,
  "background-color": "white",
  class: "filter__icon mt-2",
  "append-outer-icon": "fa-search"
};

const documentTableHeaders = [
  { text: "", value: "select", sortable: false },
  { text: "Título", value: "pessoa.nome", sortable: true },
  { text: "Arquivo", value: "arquivo.nome", sortable: true }
];
const othersDocumentsTableHeaders = [
  { text: "", value: "select", sortable: false },
  { text: "Título", value: "pessoa.nome", sortable: true },
  { text: "Tipo", value: "tipo_documento.nome", sortable: true },
  { text: "Arquivo", value: "arquivo.nome", sortable: true }
];
export default {
  name: "ConsultMarket",
  beforeRouteLeave(to, from, next) {
    if (this.cancel || this.formIsPristineCommon(this.model, this.cloneModel))
      next();
    this.modalCancel = true;
    this.nextRoute = to;
  },
  mixins: [LoadingRequest, FormMixin],
  created(){
    this.insertValuesOnBreadcrumb();
  },
  components: {
    FormSection,
    SelectBalanceDocumentsModal: SelectDocumentsModal,
    SelectOtherDocumentsModal: SelectDocumentsModal,
    ModalCancelConsultMarket
  },
  data() {
    return {
      tableHeadersInsurance,
      selectedInsurance: [],
      search: "",
      tableHeaders,
      documentTableHeaders,
      tableHeadersOthersDocuments,
      othersDocumentsTableHeaders,
      isBalanceDocumentModalOpen: false,
      isOtherDocumentModalOpen: false,
      filterProps: defaultFilterProps,
      model: {
        comentario: ""
      },
      selectedInsurer: new Set(),
      allBalanceDocuments: [],
      allOtherDocuments: [],
      balanceDocuments: { documents: [] },
      otherDocuments: { documents: [] },
      breadcrumb: null,
      errorInsurance: [],
      errorBalance: [],
      modalCancel: false,
      nextRoute: null,
      cancel: false,
      cloneModel: {
        comentario: ""
      },
      maxLengthTextArea
    };
  },
  mounted() {
    this.fetchData();
  },
  computed: {
    ...mapState("economic_group", {
      insurers: "itemsInsuranceConsultMarket"
    }),
    ...mapState("me", ["userAreaIsGarantia"]),
    groupId() {
      return this.$route.params.groupId;
    },
    formData() {
      return {
        ...this.model,
        balancos: this.balanceDocuments.documents,
        documentos: this.otherDocuments.documents,
        seguradoras: this.selectedInsurance
      };
    },
    textSubmitButton() {
      return this.userAreaIsGarantia ? "ENVIAR" : "HABILITAR"; 
    },
    alertConsultMarketMessage() {
      return this.userAreaIsGarantia ? "Solicitação de consulta enviada" : "Seguradora(s) habilitada(s) com sucesso";
    }
  },
  methods: {
    ...mapActions("economic_group", [
      "createCreditLimitConsult",
      "balanceDocumentsOfEconomicGroup",
      "otherDocumentsOfEconomicGroup",
      "requestInsuranceConsultMarket"
    ]),
    insertValuesOnBreadcrumb() {
      this.breadcrumb = this.userAreaIsGarantia ? BREADCRUMB_CONSULTAR_MERCADO : BREADCRUMB_HABILITAR_SEGURADORA;
    },
    removeDocument(key, document) {
      this[key].documents = this[key].documents.filter(
        doc => doc.arquivo.url !== document.arquivo.url
      );
    },
    selectDocument(key, document) {
      this[key].documents = _.cloneDeep(document);
    },
    onToggleBalanceModal() {
      this.isBalanceDocumentModalOpen = false;
    },
    onToggleDocumentsModal() {
      this.isOtherDocumentModalOpen = false;
    },
    onSelectBalanceDocument() {
      this.balanceDocuments.documents = Array.from(this.selectedInsurer);
      this.onToggleBalanceModal();
    },
    fetchData() {
      const self = this;
      const { groupId } = this;
      this.withLoading(
        Promise.all([
          this.balanceDocumentsOfEconomicGroup({ groupId }),
          this.otherDocumentsOfEconomicGroup({ groupId }),
          this.requestInsuranceConsultMarket({ grupo_economico_id: groupId })
        ])
      ).then(responses => {
        const [allBalanceDocuments, allOtherDocuments] = responses;
        self.allBalanceDocuments = allBalanceDocuments;
        self.allOtherDocuments = allOtherDocuments;
      });
    },
    previousPage() {
      this.$router.push({ name: "economic_group credit_limit list" });
    },
    setErrorInsurance() {
      this.errorInsurance =
        this.selectedInsurance.length > 0
          ? []
          : ["É preciso selecionar pelo menos uma seguradora"];
    },
    setErrorBalance() {
      this.errorBalance =
        this.balanceDocuments.documents.length > 0
          ? []
          : ["É preciso selecionar pelo menos um balanço"];
    },
    validate() {
      if (!this.userAreaIsGarantia) {
        return true;
      }
      this.setErrorInsurance();
      this.setErrorBalance();
      return (
        this.selectedInsurance.length > 0 &&
        this.balanceDocuments.documents.length > 0
      );
    },
    submit() {
      if (!this.validate()) return;
      this.withLoading(
        this.createCreditLimitConsult({
          groupId: this.groupId,
          info: this.formData
        }).then(() => {
          this.cancel = true;
          this.showAlertNotification({
            message: this.alertConsultMarketMessage,
            type: "success"
          });
          this.$router.push({ name: "economic_group credit_limit list" });
        })
      );
    },
    closeModalCancel(value) {
      this.cancel = value;
      this.modalCancel = false;
      if (value) {
        this.$router.push({
          name: this.nextRoute.name,
          params: this.nextRoute.params
        });
      }
    }
  }
};
</script>

<style lang="sass">
.checkbox__list
  box-sizing: border-box
  border: 1px solid #D5D5E0
  border-radius: 2px
  background-color: #F0F0F7
  padding: 0 20px 20px 20px

.quill-editor
  background-color: #fff

.insurers__list
  background: transparent !important
  padding: 0 !important

  .v-list-item
    background-color: #fff

  .v-list-item:not(:last-child)
    margin-bottom: 10px
</style>
